module.exports = __webpack_public_path__ + "static/media/Home Page_website-15.4b18e2da.png";